<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Production Journal Lines</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in items" :key="i" click>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-text-field v-model="editedItem.Qty" label="Scrap Quantity" required prepend-icon="select_all"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field v-model="editedItem.protein" label="Srap Code" prepend-icon="notes"></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outline @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" outline @click.native="save">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.protein }}</td>
        <td>{{ props.item.prodNo }}</td>
        <td>{{ props.item.prodline }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.Qty }}</td>
        <td>{{ props.item.UOM }}</td>
        <td class="text-xs-left">{{ props.item.calories }}</td>
        <td class="text-xs-left">{{ props.item.Qty }}</td>
        <td class="text-xs-left">{{ props.item.carbs }}</td>
        <td class="text-xs-left">{{ props.item.protein }}</td>

        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    search: '',
    items: [
      { title: 'Clear Items' },
      { title: 'Post Journal' },
      { title: 'Delete' }
    ],
    headers: [
      {
        text: 'Finished Date',
        align: 'left',
        sortable: true,
        value: 'finishdate'
      },
      {
        text: 'Prod.Order No.',
        align: 'left',
        value: 'prodNo'
      },
      { text: 'Prod.OrderLineNo.', value: 'prodline' },
      { text: 'Source Item No.', value: 'sourceItem' },
      { text: 'Item Description', value: 'decription' },
      { text: 'Quantity', value: 'quantity' },
      { text: 'UOM', value: 'uom' },
      { text: 'Batch Size', value: 'BatchSize' },
      { text: 'Scrap QTY', value: 'ScrapQTY' },
      { text: 'Scrap UOM', value: 'ScrapUOM' },
      { text: 'Scrap Code', value: 'ScrapCode' },
      { text: 'Action', value: 'action', align: 'right' }
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      calories: '',
      fat: '',
      carbs: '',
      protein: ''
    },
    defaultItem: {
      name: '',
      calories: '',
      fat: '',
      carbs: '',
      protein: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.desserts = [
        {
          name: 'Frozen Yogurt',
          calories: '2032',
          fat: 'Arun',
          carbs: '0012',
          protein: '2018-11-16',
          prodline: 1000,
          prodNo: 'RPO-2018-NP-001',
          Qty: 10,
          UOM: '1KG'
        },
        {
          name: 'Ice cream sandwich',
          calories: '2033',
          fat: 'Sathish',
          carbs: '00123',
          protein: '2018-11-16',
          prodline: 2000,
          prodNo: 'RPO-2018-NP-002',
          Qty: 20,
          UOM: '2KG'
        },
        {
          name: 'Eclair',
          calories: '2034',
          fat: 'Arun',
          carbs: '001234',
          protein: '2018-11-16',
          prodline: 3000,
          prodNo: 'RPO-2018-NP-003',
          Qty: 30,
          UOM: '4KG'
        }
      ];
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/widgets/list/ProductionLines.vue